import React, { useContext, useEffect, useState } from "react";
import { Flip, ToastContainer } from "react-toastify";
import {
  HashRouter as Router,
  Routes,
  Route,
  Navigate
} from "react-router-dom";

import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import 'react-medium-image-zoom/dist/styles.css'
import { check_user_permissions } from "./Controller/actions";

import { Layout, ProtectedRoutes } from "./Components";
import ConfirmationModal from "./Components/Modals/ConfirmationModal";
import Music from "./Pages/Gallery/Music";
import Sticker from "./Pages/Gallery/Sticker";
import SignIn from "./Pages/SignIn/SignIn";
import NotFound from "./Pages/NotFound/NotFound";
import StickerTags from "./Pages/Gallery/StickerTags";
import Feedback from "./Pages/Feedback/Feedback";
import Rating from "./Pages/Feedback/Rating";
import Blogs from "./Pages/Blogs/Blogs";
import BlogCategories from "./Pages/Blogs/BlogCategories";
import NewBlogs from "./Pages/Blogs/add/NewBlogs";
import Comments from "./Pages/Blogs/Comments";
import CategoryList from "./Pages/Feedback/CategoryList";
import SubCategoryList from "./Pages/Feedback/SubCategoryList";
import routes from "./routes";
import PermissionLogoutModel from "./Components/Modals/PermissionLogoutModel";
import Splash from "./Pages/Splash/Splash";
import { NewContext } from "./Context/NewContext";
import Subscription from "./Pages/Subscription/Subscription";
import Faq from "./Pages/FAQ/Faq";
import Users from "./Pages/Users/Users";
import Asset from "./Pages/Assets/Asset";
import BinaryEncoding from "./Pages/BinaryEncoding/BinaryEncoding";
import BankRegex from "./Pages/BankRegex/BankRegex";
import ApiResponse from "./Pages/ApiResponse/ApiResponse";
import SmsRegex from "./Pages/SmsRegex/SmsRegex";
import PreviewBlog from "./Pages/Blogs/PreviewBlog";
import ThemeStore from "./Pages/Theme/ThemeStore/ThemeStore";
import Wallpaper from "./Pages/Theme/Wallpaper/Wallpaper";
import Bubble from "./Pages/Theme/Bubble/Bubble";
import Font from "./Pages/Theme/Font/Font";
const socket = require('socket.io-client').connect(process.env.REACT_APP_SOCKET_URL, { transports: ['polling'] })
const App = () => {

  const { setOpenModal, permissions, setExpiryTime, handlePermissions } = useContext(NewContext)
  const [currentPath, setCurrentPath] = useState('');
  const [currentRoutes, setCurrentRoutes] = useState(routes.sidebarRoutes);
  let [homeScreenRoute, setHomeScreenRoute] = useState('')
  useEffect(() => {
    window.addEventListener('error', e => {
      if (e.message === 'ResizeObserver loop limit exceeded') {
        const resizeObserverErrDiv = document.getElementById(
          'webpack-dev-server-client-overlay-div'
        );
        const resizeObserverErr = document.getElementById(
          'webpack-dev-server-client-overlay'
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute('style', 'display: none');
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute('style', 'display: none');
        }
      }
    });
  }, [])

  //socket
  useEffect(() => {
    if (permissions?.subPermissions) {
      const data = localStorage.getItem('token');
      const [_, payload, _$] = data?.split('.');
      handlePermissions(JSON.parse(atob(payload))?.permission)
      socket.emit('join', { userId: JSON.parse(atob(payload))?._id })
    }
  }, [])

  useEffect(() => {

    socket.on(process.env.REACT_APP_PROJECT_ID, async (data) => {
      localStorage.setItem('token', data)
      const [_, payload, _$] = data?.split('.');
      handlePermissions(JSON.parse(atob(payload))?.permission)
      return () => socket.off(process.env.REACT_APP_PROJECT_ID);
    });
  }, [socket])

  //permissions
  useEffect(() => {
    if (localStorage.getItem('loginType') === 'standard') {
      setHomeScreenRoute(undefined)
      setCurrentPath('/feedback')
    }

    if (permissions?.subPermissions) {
      const updatedRoutes = currentRoutes?.filter((route) => permissions?.subPermissions?.some((permission) => {
        if (route?.key === permission?.key) return permission
        if (route?.items) {
          route.items = route?.items?.filter((route) => permissions?.subPermissions?.some((itemPermission) => route?.key === itemPermission?.key))
          if (route.items.length) {
            return route;
          }
        }
      }));

      setCurrentRoutes(updatedRoutes);
      setHomeScreenRoute(updatedRoutes.find((route) => route?.path === '/feedback'))
      homeScreenRoute = updatedRoutes.find((route) => route?.path === '/feedback')
      if (!homeScreenRoute) {
        const availableRoute = updatedRoutes[0];
        const firstObj = availableRoute?.path;
        setCurrentPath(firstObj)
      }
    }

    if (permissions && permissions?.subPermissions && permissions?.subPermissions.length === 0) {
      setOpenModal(true);
    }
    else {
      setOpenModal(false)
    }
  }, [permissions])

  const fetchPermissions = async () => {
    const permissionsData = await check_user_permissions()
    const { status, data } = permissionsData;
    if (status) {
      if (data?.length > 0 && data[0]?.subPermissions && data[0]?.subPermissions?.length > 0) {
        setOpenModal(false)
      } else {
        setOpenModal(true);
      }
    }
  }

  useEffect(() => {
    if (localStorage.getItem('loginType') === 'ldap') {
      fetchPermissions()
    }

  }, [localStorage.getItem('loginType')])

  // timer
  useEffect(() => {
    if (localStorage.getItem('token')) {
      setExpiryTime(Date.now() + (process.env.REACT_APP_SESSION_TIMEOUT_DURATION * 60 * 1000));
    }
  }, []);

  useEffect(() => {
    const handleActivity = () => {
      setExpiryTime(Date.now() + (process.env.REACT_APP_SESSION_TIMEOUT_DURATION * 60 * 1000));
    }

    document.addEventListener('click', handleActivity);
    document.addEventListener('keydown', handleActivity);

    return () => {
      document.removeEventListener('click', handleActivity);
      document.removeEventListener('keydown', handleActivity);
    };
  }, []);



  return (
    <>
      <ToastContainer position="bottom-center" transition={Flip} hideProgressBar={true} pauseOnFocusLoss={false} autoClose={400} style={{ zIndex: "9999999" }} theme="dark" />
      <Router>
        <Routes>
          <Route exact path="/" element={<ProtectedRoutes />}>
            <Route element={<Layout />}>
              {/* DASHBOARD */}
              {!homeScreenRoute ? <Route index element={<Navigate to={currentPath} />} /> :
                <Route index element={<Navigate to={'/feedback'} />} />
              }
              {/* <Route exact path="/music" element={<Music />} /> */}
              {/* <Route exact path="/sticker" element={<Sticker />} /> */}
              {/* <Route exact path="/sticker-tags" element={<StickerTags />} /> */}
              <Route exact path="/feedback" element={<Feedback />} />
              <Route exact path="/feedback-category" element={<CategoryList />} />
              <Route exact path="/feedback-sub-category" element={<SubCategoryList />} />
              <Route exact path="/rating" element={<Rating />} />
              <Route exact path="/blogs" element={<Blogs />} />
              <Route exact path="/categories" element={<BlogCategories />} />
              <Route exact path="/addBlogs" element={<NewBlogs />} />
              <Route exact path="/previewBlogs" element={<PreviewBlog />} />
              <Route exact path="/editBlogs" element={<NewBlogs />} />
              <Route exact path="/comment" element={<Comments />} />
              <Route exact path="/subscription" element={<Subscription />} />
              <Route exact path="/faq" element={<Faq />} />
              <Route exact path="/users" element={<Users />} />
              <Route exact path="/asset" element={<Asset />} />
              <Route exact path="/binaryEncoding" element={<BinaryEncoding />} />
              <Route exact path="/bankRegex" element={<BankRegex />} />
              <Route exact path="/smsRegex" element={<SmsRegex />} />
              <Route exact path="/apiResponse" element={<ApiResponse />} />
              <Route exact path="/themes" element={<ThemeStore />} />
              <Route exact path="/wallpaper" element={<Wallpaper />} />
              <Route exact path="/bubbles" element={<Bubble />} />
              <Route exact path="/font" element={<Font />} />



            </Route>
          </Route>
          <Route
            exact
            path="/splash/:loginType/:userName/:token"
            element={<Splash />}
          />
          <Route
            exact
            path="/signin"
            element={localStorage.getItem("token") ? (<Navigate to={"/"} />) : (<SignIn socket={socket} />)}
          />
          <Route exact path="/notfound" element={<NotFound />} />
          <Route path="*" element={<Navigate to="/notfound" />} />
        </Routes>
        <ConfirmationModal />
        <PermissionLogoutModel />
      </Router>
    </>
  );
};

export default App;
